import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { InputSimpleDropdown, PrimaryButton, SecondaryButton, ButtonSizeOptions, ButtonIcon } from "@loanbossinc/component-library";
import { mapCompanySelector } from "store/state/auth";
import { LBFooter } from "components";
import CircularProgress from "@material-ui/core/CircularProgress";

import { PageContainer, FooterContainer } from "./styledComponents";
import { TableWrapper, TitleWrapper } from "./dashboard.style";
import { columns } from "./dashboardColumns";
import DataTable from "./DataTable";
import DebtValuationExportModal from "./DebtValuationExportModal";
import { getDebtValuationResults, getCompanyGroups, downloadDebtValuationResults } from "./debtValuation.store";

const showFilter = false;

const HeaderContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 20px;
`;

const DebtValuationDashboard = ({ authentication, company, getCompanyGroups, companyGroups, debtValuationResults, downloadDebtValuationResults, getDebtValuationResults, history }) => {
  const [viewingDealsOfValue, setViewingDealsOfValue] = useState(-1);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [valuationDate, setValuationDate] = useState(moment().format("YYYY-MM-DD"));
  const [isDiscountDataVisible, setIsDiscountDataVisible] = useState(false);
  const [debtValuationData, setDebtValuationData] = useState([]);

  useEffect(() => {
    getDebtValuationResults({ isRefresh: false });
    getCompanyGroups();
  }, []);

  useEffect(() => {
    setDebtValuationData(debtValuationResults);
  }, [debtValuationResults]);

  const goToDeal = (dealId, loanId) => {
    const url = `/portfolio/funds/free/deals/${dealId}/cashflowsPage?showActiveLoans=true&loanId=${loanId}&isDebtValuation=true`;
    history.push(url);
  };

  const goToSettings = () => {
    const url = "/debtValuation/globalSettings";
    history.push(url);
  };

  const exportData = callback => {
    const dealIds = [];
    let fundName = "";
    if (viewingDealsOfValue !== -1) {
      debtValuationData.forEach(data => {
        dealIds.push(data.dealId);
      });
      const selectedGroup = companyGroups.filter(group => group.id === viewingDealsOfValue)[0];
      fundName = selectedGroup.name;
    }

    downloadDebtValuationResults({ callback, valuationDate, dealIds, fundName });
  };

  const toggleData = () => {
    setIsDiscountDataVisible(!isDiscountDataVisible);
  };

  const fundFilterChange = value => {
    setViewingDealsOfValue(value);
    if (value === -1) {
      setDebtValuationData(debtValuationResults);
    } else {
      const filteredResults = debtValuationResults.filter(result => result.fundIds.indexOf(value) > -1);
      setDebtValuationData(filteredResults);
    }
  };

  return (
    <PageContainer>
      <DebtValuationExportModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        onExport={callback => exportData(callback)}
        authentication={authentication}
        valuationDate={valuationDate}
        handleDatePicker={date => {
          setValuationDate(date);
        }}
      />

      <HeaderWrapper>
        <HeaderContentWrapper>
          <HeaderContentWrapper style={{ flexDirection: "column" }}>
            <TitleWrapper>Debt Valuation</TitleWrapper>
            <InputSimpleDropdown
              name={"groupSort"}
              value={viewingDealsOfValue}
              label={"Sort by group"}
              options={companyGroups}
              onChange={fundFilterChange}
            />
          </HeaderContentWrapper>
          <HeaderContentWrapper>
            <ButtonIcon iconName={"chevron_left"} onClick={toggleData} style={{ marginLeft: "10px" }} disabled={!isDiscountDataVisible} />
            <>{isDiscountDataVisible ? "Discount Info" : "Financials"}</>
            <ButtonIcon iconName={"chevron_right"} onClick={toggleData} style={{ marginLeft: "10px" }} disabled={isDiscountDataVisible} />
          </HeaderContentWrapper>
        </HeaderContentWrapper>
        <HeaderContentWrapper>
          <ButtonIcon iconName={"refresh"} onClick={() => getDebtValuationResults({ isRefresh: true })} />
          <SecondaryButton label="Settings" size={ButtonSizeOptions.sm} onClick={goToSettings} style={{ marginLeft: "20px" }} />
          <PrimaryButton label="Download" size={ButtonSizeOptions.sm} onClick={() => setIsExportModalOpen(!isExportModalOpen)} style={{ marginLeft: "20px" }} />
        </HeaderContentWrapper>
      </HeaderWrapper>

      {debtValuationData &&
        <TableWrapper>
          <DataTable columns={columns(goToDeal, isDiscountDataVisible)} data={debtValuationData} showFilter />
        </TableWrapper>}

      {!debtValuationData && <CircularProgress style={{ margin: "auto" }} />}

      <FooterContainer>
        <LBFooter />
      </FooterContainer>
    </PageContainer>
  );
};

const mapStateToProps = ({ authentication, debtValuation }) => ({
  authentication,
  company: mapCompanySelector(authentication),
  ...debtValuation
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getDebtValuationResults,
    getCompanyGroups,
    downloadDebtValuationResults
  })
)(DebtValuationDashboard);
